// extracted by mini-css-extract-plugin
export default {"video_box":"index_video_box_K613e","video":"index_video_pUT86"};